import Utils from "../Utils";
import store from "../store";

const strict = true;

function constructErrorByStatus(error, status) {
  let dataName = error.dataName;
  let error_title, error_msg, error_action_btn, error_action_btn_clb;
  if (dataName && status) {
    let errorHeaders = error
      ? error.reason
        ? error.reason.response
          ? error.reason.response.headers
          : null
        : null
      : null;
    // sometimes the response object is not inside the reason object
    if (!errorHeaders) {
      errorHeaders = error
        ? error.response
          ? error.response.headers
          : null
        : null;
    }
    let existsExceptionType = Utils.existsXOnairExceptionType(errorHeaders);
    let existsExceptionMsg = Utils.existsXOnairExceptionMessage(errorHeaders);
    if (existsExceptionType && existsExceptionMsg) {
      let exceptionType = Utils.getXOnairExceptionType(errorHeaders);
      let exceptionMsg = Utils.getXOnairExceptionMessage(errorHeaders);
      if (exceptionType && exceptionType === "AuthorizationException") {
        // com.bizmatica.onair.core.model.runtime.security.AuthorizationException
        let actionBtnClb = () => {
          store.dispatch("logout", null, {
            root: true
          });
        };
        if (exceptionMsg.startsWith("Authentication failed")) {
          error_title = `dialogs.error.statuses.wrongCredentials.title`;
          error_msg = `dialogs.error.statuses.wrongCredentials.msg`;
          error_action_btn = `dialogs.error.statuses.wrongCredentials.btn`;
          error_action_btn_clb = actionBtnClb;
        } else if (status == 401 || status == 403) {
          error_title = `dialogs.error.statuses.${status}.title`;
          error_msg = `dialogs.error.statuses.${status}.msg`;
          error_action_btn = `dialogs.error.statuses.${status}.btn`;
          error_action_btn_clb = actionBtnClb;
        } else {
          error_title = "dialogs.error.statuses.401.title";
          error_msg = "dialogs.error.statuses.401.msg";
          error_action_btn = "dialogs.error.statuses.401.btn";
          error_action_btn_clb = actionBtnClb;
        }
      } else if (exceptionType && exceptionType === "UserNotFoundException") {
        // nest.common.UserNotFoundException
        if (exceptionMsg?.startsWith("[recoverPassword]")) {
          error_title = "homepage.login.errors.recoverPassword.title";
          error_msg = "homepage.login.errors.recoverPassword.msg";
          error_action_btn = "homepage.login.errors.recoverPassword.btn";
        } else if (exceptionMsg?.startsWith("[recoverUsername]")) {
          error_title = "homepage.login.errors.recoverUsername.title";
          error_msg = "homepage.login.errors.recoverUsername.msg";
          error_action_btn = "homepage.login.errors.recoverUsername.btn";
        } else {
          error_title = `${dataName}.errors.${status}.title`;
          error_msg = `${dataName}.errors.${status}.msg`;
          error_action_btn = `${dataName}.errors.${status}.btn`;
        }
      } else if (
        exceptionType &&
        exceptionType === "UserNotAssociatedToAnyOfficeException"
      ) {
        // nest.common.UserNotAssociatedToAnyOfficeException
        error_title = "homepage.login.errors.no-offices.title";
        error_msg = "homepage.login.errors.no-offices.msg";
        error_action_btn = "homepage.login.errors.no-offices.btn";
      } else if (
        exceptionType &&
        exceptionType === "AppointmentChangeNotAllowedDueDateException"
      ) {
        // nest.common.AppointmentChangeNotAllowedDueDateException
        error_title = `${dataName}.errors.appointmentChangeNotAllowedDueDate.title`;
        error_msg = `${dataName}.errors.appointmentChangeNotAllowedDueDate.msg`;
        error_action_btn = `${dataName}.errors.appointmentChangeNotAllowedDueDate.btn`;
      }
      // nest.common.InvalidBillStateException
      else if (exceptionType && exceptionType === "InvalidBillStateException") {
        let messages = ["Bill state SENT not allowed"];
        if (exceptionMsg && messages.includes(exceptionMsg)) {
          error_title = `${dataName}.errors.invalidBillState.title`;
          error_msg = `${dataName}.errors.invalidBillState.msg`;
          error_action_btn = `${dataName}.errors.invalidBillState.btn`;
        } else {
          error_title = `${dataName}.errors.${status}.title`;
          error_msg = `${dataName}.errors.${status}.msg`;
          error_action_btn = `${dataName}.errors.${status}.btn`;
        }
      }
      // nest.common.FlowErrorException
      else if (exceptionType && exceptionType == "FlowErrorException") {
        if (exceptionMsg && exceptionMsg === "cannot send bill") {
          error_title = `${dataName}.errors.flowErrorInvalidOperation.cannotSendBill.title`;
          error_msg = `${dataName}.errors.flowErrorInvalidOperation.cannotSendBill.msg`;
          error_action_btn = `${dataName}.errors.flowErrorInvalidOperation.cannotSendBill.btn`;
        } else if (
          exceptionMsg &&
          exceptionMsg === "Appointment cannot be added"
        ) {
          error_title = `${dataName}.errors.flowErrorInvalidOperation.appCannotBeAdded.title`;
          error_msg = `${dataName}.errors.flowErrorInvalidOperation.appCannotBeAdded.msg`;
          error_action_btn = `${dataName}.errors.flowErrorInvalidOperation.appCannotBeAdded.btn`;
        } else if (
          exceptionMsg &&
          exceptionMsg === "Cannot generate fascicolo"
        ) {
          error_title = `${dataName}.errors.flowErrorInvalidOperation.cannotGenerateFascicolo.title`;
          error_msg = `${dataName}.errors.flowErrorInvalidOperation.cannotGenerateFascicolo.msg`;
          error_action_btn = `${dataName}.errors.flowErrorInvalidOperation.cannotGenerateFascicolo.btn`;
        } else if (exceptionMsg?.startsWith("Invalid InvoiceDate [")) {
          error_title = `${dataName}.errors.flowErrorInvalidOperation.invalidInvoiceDate.title`;
          error_msg = `${dataName}.errors.flowErrorInvalidOperation.invalidInvoiceDate.msg`;
          error_action_btn = `${dataName}.errors.flowErrorInvalidOperation.invalidInvoiceDate.btn`;
        } else {
          error_title = `${dataName}.errors.${status}.title`;
          error_msg = `${dataName}.errors.${status}.msg`;
          error_action_btn = `${dataName}.errors.${status}.btn`;
        }
      }
      // nest.common.AliasEqualsToOfficialNameException
      else if (
        exceptionType &&
        exceptionType === "AliasEqualsToOfficialNameException"
      ) {
        error_title = `${dataName}.errors.aliasEqualsToOfficialName.title`;
        error_msg = `${dataName}.errors.aliasEqualsToOfficialName.msg`;
        error_action_btn = `${dataName}.errors.aliasEqualsToOfficialName.btn`;
      }
      // nest.common.NoMoreResidualException
      else if (exceptionType && exceptionType === "NoMoreResidualException") {
        error_title = `${dataName}.errors.noMoreResidual.title`;
        error_msg = `${dataName}.errors.noMoreResidual.msg`;
        error_action_btn = `${dataName}.errors.noMoreResidual.btn`;
      }
      // nest.common.NotBookableByRuleException
      else if (
        exceptionType &&
        exceptionType === "NotBookableByRuleException"
      ) {
        error_title = `${dataName}.errors.notBookableByRule.title`;
        error_msg = `${dataName}.errors.notBookableByRule.msg`;
        error_action_btn = `${dataName}.errors.notBookableByRule.btn`;
      }
      // nest.common.NotCoveredException
      else if (exceptionType && exceptionType === "NotCoveredException") {
        error_title = `${dataName}.errors.notCovered.title`;
        error_msg = `${dataName}.errors.notCovered.msg`;
        error_action_btn = `${dataName}.errors.notCovered.btn`;
      }
      // nest.common.MaxCeilingReachedException
      else if (
        exceptionType &&
        exceptionType === "MaxCeilingReachedException"
      ) {
        error_title = `${dataName}.errors.maxCeilingReached.title`;
        error_msg = `${dataName}.errors.maxCeilingReached.msg`;
        error_action_btn = `${dataName}.errors.maxCeilingReached.btn`;
      }
      // nest.common.MaxHealthCareReachedException
      else if (
        exceptionType &&
        exceptionType === "MaxHealthCareReachedException"
      ) {
        error_title = `${dataName}.errors.maxHealthCareReached.title`;
        error_msg = `${dataName}.errors.maxHealthCareReached.msg`;
        error_action_btn = `${dataName}.errors.maxHealthCareReached.btn`;
      }
      // nest.common.InvalidSlotException
      else if (exceptionType && exceptionType === "InvalidSlotException") {
        if (
          exceptionMsg?.startsWith(
            "No period slot configure for request hfOffice"
          )
        ) {
          error_title = `${dataName}.errors.invalidSlotException.noSlotConfiguredForOffice.title`;
          error_msg = `${dataName}.errors.invalidSlotException.noSlotConfiguredForOffice.msg`;
          error_action_btn = `${dataName}.errors.invalidSlotException.noSlotConfiguredForOffice.btn`;
        } else if (exceptionMsg?.startsWith("Invalid slot request")) {
          error_title = `${dataName}.errors.invalidSlotException.noSlotAvailable.title`;
          error_msg = `${dataName}.errors.invalidSlotException.noSlotAvailable.msg`;
          error_action_btn = `${dataName}.errors.invalidSlotException.noSlotAvailable.btn`;
        } else {
          error_title = `${dataName}.errors.${status}.title`;
          error_msg = `${dataName}.errors.${status}.msg`;
          error_action_btn = `${dataName}.errors.${status}.btn`;
        }
      }
      // nest.common.TimeTableNotConfiguredException
      else if (
        exceptionType &&
        exceptionType === "TimeTableNotConfiguredException"
      ) {
        error_title = `${dataName}.errors.timeTableNotConfigured.title`;
        error_msg = `${dataName}.errors.timeTableNotConfigured.msg`;
        error_action_btn = `${dataName}.errors.timeTableNotConfigured.btn`;
      }
      // nest.common.MemberProfileMissingDataException
      else if (
        exceptionType &&
        exceptionType === "MemberProfileMissingDataException"
      ) {
        error_title = `${dataName}.errors.missingContactData.title`;
        error_msg = `${dataName}.errors.missingContactData.msg`;
        error_action_btn = `${dataName}.errors.missingContactData.btn`;
      }
      // nest.common.DoctorHasScheduledAppointmentException
      else if (
        exceptionType &&
        exceptionType === "DoctorHasScheduledAppointmentException"
      ) {
        error_title = `${dataName}.errors.doctorHasScheduledAppointment.title`;
        error_msg = `${dataName}.errors.doctorHasScheduledAppointment.msg`;
        error_action_btn = `${dataName}.errors.doctorHasScheduledAppointment.btn`;
      }
      // nest.common.InvalidTokenFromEmailException
      else if (
        exceptionType &&
        exceptionType === "InvalidTokenFromEmailException"
      ) {
        error_title = `${dataName}.errors.invalidTokenFromEmail.title`;
        error_msg = `${dataName}.errors.invalidTokenFromEmail.msg`;
        error_action_btn = `${dataName}.errors.invalidTokenFromEmail.btn`;
      } else if (
        exceptionType &&
        exceptionType === "InvalidDataProvidedException"
      ) {
        let messages = ["mother service"];
        if (exceptionMsg && exceptionMsg.includes(messages)) {
          error_title = `${dataName}.errors.serviceIsNotMother.title`;
          error_msg = `${dataName}.errors.serviceIsNotMother.msg`;
          error_action_btn = `${dataName}.errors.serviceIsNotMother.btn`;
        } else {
          error_title = `${dataName}.errors.${status}.title`;
          error_msg = `${dataName}.errors.${status}.msg`;
          error_action_btn = `${dataName}.errors.${status}.btn`;
        }
      }
      //
      else {
        error_title = `${dataName}.errors.${status}.title`;
        error_msg = `${dataName}.errors.${status}.msg`;
        error_action_btn = `${dataName}.errors.${status}.btn`;
      }
    } else {
      error_title = `${dataName}.errors.${status}.title`;
      error_msg = `${dataName}.errors.${status}.msg`;
      error_action_btn = `${dataName}.errors.${status}.btn`;
    }
  } else {
    let commonStatuses = [400, 401, 403, 404, 409, 412, 500, 503];
    if (commonStatuses.includes(status)) {
      error_title = `dialogs.error.statuses.${status}.title`;
      error_msg = `dialogs.error.statuses.${status}.msg`;
      error_action_btn = `dialogs.error.statuses.${status}.btn`;
    } else {
      error_title = `dialogs.error.default.title`;
      error_msg = `dialogs.error.default.msg`;
      error_action_btn = `dialogs.error.default.btn`;
    }
  }

  return {
    title: error_title,
    msg: error_msg,
    actionBtn: error_action_btn,
    actionBtnClb: error_action_btn_clb
  };
}

const getDefaultState = () => {
  return {
    errorDialog: {
      active: false,
      title: null,
      msg: null,
      params: {
        title: null,
        msg: null
      },
      actionBtn: null,
      actionBtnClb: null
    }
  };
};

const state = getDefaultState();

const getters = {
  errorDialog: state => state.errorDialog
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_ERROR(state, error) {
    state.errorDialog.active = true;
    // ERROR WITH A KNOWN STATUS (i.e 404)
    if (error.type == Utils.errorTypes.STATUS) {
      let statusCode = error.status ? error.status : error.reason.status;
      // !NOTE: INTERCEPTOR WILL HANDLE NOT AUTHORIZATION ISSUES
      let dialogContent = constructErrorByStatus(error, statusCode);
      state.errorDialog.title = dialogContent.title;
      state.errorDialog.msg = dialogContent.msg;
      if (error.params?.title || error.params?.msg) {
        state.errorDialog.params.title = dialogContent.params.title;
        state.errorDialog.params.msg = dialogContent.params.msg;
      }
      state.errorDialog.actionBtn = dialogContent.actionBtn;
      state.errorDialog.actionBtnClb = dialogContent.actionBtnClb;
    }
    // ERROR WITH WITH A SWAGGER CLIENT (i.e NETWORK PROBLEM)
    else if (error.type == Utils.errorTypes.UNABLE_TO_CALL_API) {
      const BASE_PATH = "dialogs.error.unableToCallApi";
      state.errorDialog.title = `${BASE_PATH}.title`;
      state.errorDialog.msg = `${BASE_PATH}.msg`;
      state.errorDialog.params.msg = {
        errorDetails: JSON.stringify(error.reason)
      };
      state.errorDialog.actionBtn = `${BASE_PATH}.btn`;
      state.errorDialog.actionBtnClb = error.actionBtnClb;
    }
    // ERROR WITH A CUSTOM ERROR MESSAGE FROM APP
    else if (error.type == Utils.errorTypes.CUSTOM) {
      state.errorDialog.title = error.title;
      state.errorDialog.msg = error.msg;
      if (error.params?.title || error.params?.msg) {
        state.errorDialog.params.title = error.params.title;
        state.errorDialog.params.msg = error.params.msg;
      }
      state.errorDialog.actionBtn = error.actionBtn;
      state.errorDialog.actionBtnClb = error.actionBtnClb;
    }
    // DEFAULT ERROR
    else {
      state.errorDialog.title = "dialogs.error.default.title";
      state.errorDialog.msg = "dialogs.error.default.msg";
      state.errorDialog.actionBtn = "dialogs.error.default.btn";
      state.errorDialog.actionBtnClb = error.actionBtnClb;
    }
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
